<script setup>
import Calendar from "primevue/calendar";
import { ref, defineProps, defineEmits, onMounted, onBeforeMount, computed } from "vue";
import { useTerritoriosStore } from "@/store/territorios";
import { useTrabajoStore } from "@/store/useTrabajoStore";

import { useScreenStore } from "@/store/useScreenStore";

const screen = useScreenStore();

const emit = defineEmits(["selected"]);

const props = defineProps({
  start: {
    type: Date,
    default: null,
  },
  onlyIncomplete: {
    type: Boolean,
    default: false,
  },
  lead: {
    type: Boolean,
    default: false,
  },
  filter: {
    type: Boolean,
    default: false,
  },
  selectable: {
    type: Boolean,
    default: false,
  },
  showDetail: {
    type: Boolean,
    default: false,
  }
});

const territorios = useTerritoriosStore();
const trabajo = useTrabajoStore();

onBeforeMount(async () => {
  await trabajo.syncHistory()
});



const asignados = computed(() => {
  
  let data = {}
  for (let i in territorios.asignadosActivos) {
    for (let j in territorios.asignadosActivos[i].territorios) {
      data[territorios.asignadosActivos[i].territorios[j]] = true;
    }
  }
  return data;
});
const pages = ref([]);
const start = ref(null);

function customSort(a, b) {
    const regExp = /^[A-Z]+|\d+/g;

    const aTokens = a.match(regExp);
    const bTokens = b.match(regExp);

    const aLetter = aTokens[0];
    const bLetter = bTokens[0];

    if (aLetter !== bLetter) {
        return aLetter.localeCompare(bLetter);
    } else {
        const aNumber = parseInt(aTokens[1]);
        const bNumber = parseInt(bTokens[1]);
        return aNumber - bNumber;
    }
}

const generar = () => {
  pages.value = []
  let page = {};
  if (!start.value) {
    return;
  }
  const date = start.value;
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  añoServicio.value = month > 8 ? year + 1 : year;
  let startTimestamp = date.getTime();
  let maxRegistro = 0;
  const registrosPorTerritorio = {}

  // trabajo.data is keyed by UUID; resolve via territorios.listWithName
  for (const t of territorios.listWithName) {
    const displayKey = t.territorio_nombre;
    const uuid = t.uuid;
    if (!uuid) continue;
    const workData = trabajo.data[uuid];
    if (!workData) continue;
    const ciclos = trabajo.getCiclos(workData)
    const registro = ciclos.filter(c => c.inicio >= startTimestamp)
    registrosPorTerritorio[displayKey] = registro
    if (registro.length > maxRegistro) {
      maxRegistro = registro.length;
    }
  }

  let totalPages = Math.ceil(maxRegistro / 4);
  if (totalPages == 0) {
    totalPages = 1;
  }
  for (let i = 0; i < totalPages; i++) {
    page[i] = [];
  }

  // listWithName is already sorted; extract display keys in order
  const keys = territorios.listWithName.map(t => t.territorio_nombre);

  for (const displayKey of keys) {
    if (!Object.prototype.hasOwnProperty.call(registrosPorTerritorio, displayKey)) continue;

    if (page[0].length == 20) {
      for (let j = 0; j < totalPages; j++) {
        if (props.lead === true && pages.value.length > 0) {
          pages.value[0] = [...pages.value[0], ...page[j]];
          page[j] = [];
          continue;
        }
        pages.value.push(page[j]);
        page[j] = [];
      }
    }

    const uuid = territorios.data[displayKey]?.uuid;
    const workData = uuid ? trabajo.data[uuid] : null;
    if (!workData) continue;

    const territorioData = { ...workData, name: displayKey }
    for (let j = 0; j < totalPages; j++) {
      const startIndex = j * 4;
      const informe = registrosPorTerritorio[displayKey].slice(startIndex, startIndex + 4);
      const informeLength = informe.length;

      if (props.onlyIncomplete) {
        const ultimoCiclo = registrosPorTerritorio[displayKey].at(-1)
        if (informeLength === 0 || ultimoCiclo?.fin !== null) continue
      }

      page[j].push({ ...territorioData, informe });
    }
  }
  for (let j = 0; j < totalPages; j++) {
    if (page[j].length == 0) {
      break;
    }
    // console.log("page[j]>>", props.lead, j, pages.value, page[j]);
    if (props.lead === true) {
      if (pages.value.length > 0) {
        pages.value[0] = [...pages.value[0], ...page[j]];
        page[j] = [];
        continue;
      }
    }
    pages.value.push(page[j]);
    page[j] = [];
  }

  if (!props.lead) {
    // verificar que tenga minimo 20 registros por pagina
    // console.log("pages>>", pages);
    pages.value = pages.value.map((item) => {
      if (item.length < 20) {
        const addToInforme = 20 - item.length;
        // console.log("informe>>", i, informe, informe.length, addToInforme);
        for (let k = 0; k < addToInforme; k++) {
          // console.log("informe>>", i, k, informe.length);
          item.push({});
        }
      }
      return item;
    });
  }



};

// año de servicio comienza en septiembre
const añoServicio = ref(null);

const style12 = ref({ width: "12mm" });
const style22 = ref({ width: "22mm" });

onMounted(() => {
  if (props.lead) {
    style12.value = {};
    style22.value = {};
  }
  if (props.start) {
    start.value = props.start;
    generar();
  }
});
const filter = ref("");
const onSelected = (item) => {
  // console.log("onSelected>>", item);
  emit("selected", item);
};

const getData = (page, filter) => {
  // console.log("getData>>", page, filter);
  if (!filter) {
    return page;
  }
  const filterL = filter.toLowerCase();
  return page.filter((item) => {
    return item.name.toLowerCase().includes(filterL);
  });
};

const getDate = (timestamp) => {
  // console.log("getDate>>", timestamp);
  if (!timestamp) {
    return "";
  }
  return trabajo.getDate(timestamp);
};

const getInforme = (informe) => {
  let items = informe || [];

  if (items.length < 4) {
    const addToInforme = 4 - items.length;
    // console.log("informe>>", i, informe, informe.length, addToInforme);
    for (let k = 0; k < addToInforme; k++) {
      // console.log("informe>>", i, k, informe.length);
      items.push({
        conductor: "",
        inicio: null,
        fin: null,
    });
    }
  }

  return items;
};
</script>
<template>
  <div class="grid w-full relative overflow-auto" :class="{ 'mx-auto': !props.lead, noprint: props.lead }">
    <div class="col-12 noprint"  v-if="!props.lead">
      <h1 class="text-center">Informes de territorio</h1>
      <div class="flex gap-2 flex-column">
        <label for="">Seleccione fecha de inicio:</label>
        <Calendar v-model="start" dateFormat="dd/mm/yy" />
        <Button @click="generar" label="Generar" data-e2e="btn-generar-informe" />
      </div>
    </div>
    <div class="col-12 px-0 grid" v-if="props.filter">
      <div class="col-12 grid grid-nogutter">
        <div class="flex flex-column gap-2 col-12 md:col-6">
          <div>
            <label for="">Seleccione fecha de inicio:</label>
          </div>
          <div class="flex gap-2 flex-column md:flex-row">
            <Calendar v-model="start" dateFormat="dd/mm/yy" />
            <Button @click="generar" label="Buscar" />
          </div>
        </div>
        <div class="flex gap-0 col-12 md:col-6 flex-column">
          <div class="mb-2">
            Territorio:
          </div>
          <IconField iconPosition="left">
              <InputIcon class="pi pi-filter"> </InputIcon>
              <InputText
                v-model="filter"
                placeholder="Filtrar"
              />
          </IconField>
        </div>
        

      </div>
    </div>
    <div class="relative overflow-auto w-full ">
      <div
        :class="{ 'page': !props.lead || screen.isMobile, 'text-gray-900': props.lead, 'h-auto': screen.isMobile }"
        v-for="(page, pageIndex) in pages"
        :key="pageIndex"
      >
        <div v-if="!props.lead">
          <h1>REGISTRO DE ASIGNACIÓN DE TERRITORIO</h1>
        </div>
        <div class="text-left" v-if="!props.lead">
          <h3>
            Año de Servicio: <span class="year">{{ añoServicio }}</span>
          </h3>
        </div>
        <div>
          <div :class="{ 'table': !props.lead, 'lead leadtbody': props.lead }">
            <table>
              <thead>
              <tr>
                <th class="border-right-1" :style="style12">
                  <div class="wp">Núm<br />de terr.</div>
                </th>
                <th class="border-right-3" :style="style22" v-if="!props.lead">
                  <div class="wp">
                    Última fecha<br />
                    en que se<br />
                    completó*
                  </div>
                </th>
  
                <th class="border-right-3"  v-if="props.showDetail">
                  <div class="wp">
                    Detalle
                  </div>
                </th>
                <th class="border-right-2">
                  <div class="grid grid-nogutter">
                    <div class="col-12 ptop">
                      <div class="wp">Asignado a</div>
                    </div>
                    <div class="col-6 pleft">
                      <div class="wp">Fecha en que<br />se asignó</div>
                    </div>
                    <div class="col-6 right">
                      <div class="wp">Fecha en que<br />se completó</div>
                    </div>
                  </div>
                </th>
                <th class="border-right-2">
                  <div class="grid grid-nogutter">
                    <div class="col-12 ptop">
                      <div class="wp">Asignado a</div>
                    </div>
                    <div class="col-6 pleft">
                      <div class="wp">Fecha en que<br />se asignó</div>
                    </div>
                    <div class="col-6 right">
                      <div class="wp">Fecha en que<br />se completó</div>
                    </div>
                  </div>
                </th>
                <th class="border-right-2">
                  <div class="grid grid-nogutter">
                    <div class="col-12 ptop">
                      <div class="wp">Asignado a</div>
                    </div>
                    <div class="col-6 pleft">
                      <div class="wp">Fecha en que<br />se asignó</div>
                    </div>
                    <div class="col-6 right">
                      <div class="wp">Fecha en que<br />se completó</div>
                    </div>
                  </div>
                </th>
                <th class="border-right-2">
                  <div class="grid grid-nogutter">
                    <div class="col-12 ptop">
                      <div class="wp">Asignado a</div>
                    </div>
                    <div class="col-6 pleft">
                      <div class="wp">Fecha en que<br />se asignó</div>
                    </div>
                    <div class="col-6 right">
                      <div class="wp">Fecha en que<br />se completó</div>
                    </div>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, key) in getData(page, filter)"
                  @click="onSelected(item.name)"
                  class="row"
                  :class="{ 'hover:bg-gray-200 cursor-pointer': props.selectable, 'bg-red-100': asignados[item.name] && props.lead }"
                  :key="key"
    
                >
                  <td class="border-right-1 text-center">
                    <div class="wp">{{ item.name || '' }}</div>
                    </td>
                  <td class="border-right-3" v-if="!props.lead"></td>
                  <td class="border-right-3" v-if="props.showDetail">
                    <div class="wp white-space-normal line-height-3" style="width: 200px;">
                      {{territorios.data[item.name]?.referencia}}
  
                    </div>
                    <div class="wp text-xs font-bold text-red-500" v-if="props.showDetail && (item.manzanasPendientesTotal !== item.manzanasTotal) ">Pendiente: {{ item.manzanasPendientesTotal }} de {{ item.manzanasTotal }}</div>
                  
                  </td>
                  <td class="border-right-2" v-for="(informe, cicloIndex) in getInforme(item.informe)" :key="cicloIndex">
                    <div class="grid grid-nogutter">
                      <div class="col-12 ptop">
                        <div class="wp" style="margin-top: 4px">
                          {{ informe.conductor }}
                        </div>
                      </div>
                      <div class="col-6 pleft">
                        <span>
                          <div class="wp" style="margin-top: 4px">
                            {{getDate(informe.inicio) }}
                          </div>
                        </span>
                      </div>
                      <div class="col-6">
                        <span>
                          <div class="wp" style="margin-top: 4px">
                            {{ getDate(informe.fin) }}
                          </div>
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-left" v-if="!props.lead">
          <p class="msg">
            *Cuando comience una nueva página, anote en esta columna la última
            fecha en que los territorios se completaron.
          </p>
          <p class="foot">S-13-S 1/22</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.page {
  page-break-before: always;
  width: 220mm;
  height: 297mm;
  margin: 0 auto;
  color: black;
  overflow: auto;
}
.page,
.page * {
  font-family: Arial, Helvetica, sans-serif !important;
}
h1 {
  margin-top: 13mm;
  font-size: 23px;
  margin-left: -8mm;
}
h3 {
  font-size: 15.5px;
  margin-top: 5mm;
}

.leadtbody {
  height: 600px;
  overflow: auto;
}

.table {
  font-size: 12px;
  border: 3px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  font-weight: lighter;
}

.lead table {
  border: 2px solid black;
}
.lead * {
  padding: 0;
}
.lead .wp {
  padding: 3px;
  font-size: .8em;
}
table {
  width: 100%;
  border-collapse: collapse;
}

th {
  background: var(--bg-secondary);
  font-weight: var(--weight-medium);
  padding: 0px 0px !important;
  font-size: 1em;
  color: var(--label-secondary);
}

.pleft,
.bl {
  border-right: 1px solid black;
}
.ptop {
  border-bottom: 1px solid black;
}
.table th .ptop {
  padding: 2px 0;
}

.table th .pleft {
  /* height: 19mm; */
  padding-bottom: 2px;
}
th,
td {
  border-bottom: 2px solid black;
}

td,
td > div.grid,
th > div.grid {
  padding: 0px 0px !important;
}
.table td .pleft,
.table td .ptop {
  height: 6mm;
}
.msg {
  font-size: 14.3px;
  padding-top: 1mm;
}

.foot {
  margin-top: 2mm;
}

.year {
  border-bottom: 1.5px solid black;
  width: 23mm;
  display: inline-block;
  text-align: center;
  padding-bottom: 1mm;
  margin-left: 1mm;
}

.wp {
  min-height: 1em;
}
</style>
